(function (app, ng) {
    app.controller("addOpportunityController", addOpportunityController);

    addOpportunityController.$inject = ["$mdDialog", "marketingTrackerSalesTrackerInputApi", "marketingTrackerSalesTrackerSettingsApi", "$q"];
    function addOpportunityController($mdDialog, marketingTrackerSalesTrackerInputApi, marketingTrackerSalesTrackerSettingsApi, $q) {
        var $ctrl = this;
        ng.extend($ctrl, {
            opportunity: {
                Date: null,
                ClientName: null,
                Source: null,
                Status: null,
                Advisors: [],
                OpportunityAmount: 0,
                SoldAmount: 0,
                FirstAppointmentDate: null,
                NextFollowUpDate: null,
                Notes: null
            },
            today: new Date().toLocaleDateString(),
            isLoading: true,
            hasError: false,
            opportunityCreationSuccess: false
        });

        function prefillOpportunity() {
            $ctrl.opportunity.Date = $ctrl.today;
            $ctrl.opportunity.ClientName = $ctrl.clientName;
            $ctrl.isLoading = false;
        }

        $ctrl.createOpportunity = function () {
            $ctrl.isLoading = true;
            return marketingTrackerSalesTrackerInputApi.createOpportunity($ctrl.opportunity)
                .then(function (response) {
                    $ctrl.isLoading = false;
                    $ctrl.opportunityCreationSuccess = true;
                })
                .catch(function () {
                    $ctrl.isLoading = false;
                    $ctrl.hasError = true;
                })
        }

        $ctrl.close = function () {
            $mdDialog.cancel();
        }

        function getSalesTrackerSources() {
            return marketingTrackerSalesTrackerSettingsApi.getSources().then(function (response) {
                $ctrl.sources = response;
            });
        }

        function getSalesTrackerAdvisors() {
            return marketingTrackerSalesTrackerSettingsApi.getAdvisors().then(function (response) {
                $ctrl.advisors = response;
            });
        }

        function getSalesTrackerStatuses() {
            return marketingTrackerSalesTrackerSettingsApi.getStatuses().then(function (response) {
                $ctrl.statuses = response;
            });
        }

        $ctrl.$onInit = function () {
            $ctrl.currentYear = (new Date()).getUTCFullYear();
            var promises = []
            promises.push(getSalesTrackerSources());
            promises.push(getSalesTrackerAdvisors());
            promises.push(getSalesTrackerStatuses());

            $q.all(promises)
                .then(function () {
                    prefillOpportunity();
                })
                .catch(function () {
                    this.hasError = true;
                })
        }

    }
})(window.app, window.angular);